import { ReactElement } from "react";

import Button from "hardcover-ui/components/Button";
import { ButtonThemeProps } from "hardcover-ui/theme/components/button";

type BackLinkProps = {
  size?: ButtonThemeProps["size"];
  variant?: ButtonThemeProps["variant"];
  children: ReactElement;
};

export function BackButton({
  size = "lg",
  variant = "primary",
  children,
}: BackLinkProps) {
  function goBack() {
    window.history.back();
  }

  return (
    <Button variant={variant} size={size} onClick={() => goBack()}>
      {children}
    </Button>
  );
}
